const initialState = {
  isLoading: false,
  chats: null,
  activities: {},
  hasNewActivities: null,
}

export default function chat(state = initialState) {
  return state
}
